<template lang="pug">
.sticky-footer.mobile
  .footer-content(v-if="$store.state.mobileStickyFooter.type === 'filter'")
    .nav(@click="activateMobileSidebar" gtm-label="mobile-footer.toggle-mobile-sidebar")
      img(src="../assets/images/icons/menu.png", v-if="!$store.state.mobileSidebarActivated")
      img(src="../assets/images/icons/close-yellow.png", v-if="$store.state.mobileSidebarActivated")
    .search(@click="searchEnabled = !searchEnabled", :class="{ 'borderless': searchEnabled }")
      img(src="../assets/images/icons/search.png")
    template(v-if="!searchEnabled")
      .filter(@click="toggleFilterTab" gtm-label="mobile-footer.toggle-filter-tab")
        span Filter
    template(v-if="searchEnabled")
      .search-container(v-if="searchEnabled")
        input(type="text", v-model="searchValue", placeholder="Type here to start searching...", @change="searchProduct")

  .footer-content(v-if="$store.state.mobileStickyFooter.type === 'filterSort'")
    .nav(@click="activateMobileSidebar" gtm-label="mobile-footer.toggle-mobile-sidebar")
      img(src="../assets/images/icons/menu.png", v-if="!$store.state.mobileSidebarActivated")
      img(src="../assets/images/icons/close-yellow.png", v-if="$store.state.mobileSidebarActivated")
    .search(@click="searchEnabled = !searchEnabled", :class="{ 'borderless': searchEnabled }")
      img(src="../assets/images/icons/search.png")
    template(v-if="!searchEnabled")
      .filter(@click="toggleFilterTab" gtm-label="mobile-footer.toggle-filter-tab")
        span Filter
    template(v-if="searchEnabled")
      .search-container(v-if="searchEnabled")
        input(type="text", v-model="searchValue", placeholder="Type here to start searching...", @change="searchProduct")
    .sort-by
      select(v-model="sortValue", @change="updateSortByValue" gtm-label="mobile-footer.toggle-filter")
        option(value="") SORT BY
        option(value="latest") Latest
        option(value="priceAsc") Prices low to high
        option(value="priceDesc") Prices high to low
        option(value="available") Availability
        // option(value="brickAsc") BRICK COUNT Asc
        // option(value="brickDesc") BRICK COUNT Desc

  .footer-content(v-if="$store.state.mobileStickyFooter.type === 'addToCart'")
    .nav(@click="activateMobileSidebar" gtm-label="mobile-footer.toggle-mobile-sidebar")
      img(src="../assets/images/icons/menu.png", v-if="!$store.state.mobileSidebarActivated")
      img(src="../assets/images/icons/close-yellow.png", v-if="$store.state.mobileSidebarActivated")
    .search(@click="searchEnabled = !searchEnabled", :class="{ 'borderless': searchEnabled }")
      img(src="../assets/images/icons/search.png")
    template(v-if="!searchEnabled")
      .add-to-cart(v-if="$store.state.currentSelectedProduct.stock > 0", @click="addToCart($store.state.currentSelectedProduct)" gtm-label="mobile-footer.add-to-cart-button")
        span Add to Cart {{ quantityInCart() }}
      .out-of-stock(v-if="$store.state.currentSelectedProduct.stock <= 0", @click="showNotifyMeModal($store.state.currentSelectedProduct.id)" gtm-label="mobile-footer.show-notify-me")
        span Notify Me
    template(v-if="searchEnabled")
      .search-container(v-if="searchEnabled")
        input(type="text", v-model="searchValue", placeholder="Type here to start searching...", @change="searchProduct")
    .favourite
      img.favourite-icon(v-if="inWishList($store.state.currentSelectedProduct.id)", src="../assets/images/icons/favourite-round-red.png", @click="removeWishlistItem($store.state.currentSelectedProduct.id)" gtm-label="mobile-footer.remove-wishlist-item")
      img.favourite-icon(v-if="!inWishList($store.state.currentSelectedProduct.id)", src="../assets/images/icons/favourite-round-grey.png", @click="addToWishlist($store.state.currentSelectedProduct.id)" gtm-label="mobile-footer.add-to-wishlist")

  .footer-content(v-if="$store.state.mobileStickyFooter.type === 'cart'")
    // .nav(@click="activateMobileSidebar" gtm-label="mobile-footer.toggle-mobile-sidebar")
    //   img(src="../assets/images/icons/menu.png", v-if="!$store.state.mobileSidebarActivated")
    //   img(src="../assets/images/icons/close-yellow.png", v-if="$store.state.mobileSidebarActivated")
    // .search( @click="searchEnabled = !searchEnabled", :class="{ 'borderless': searchEnabled }")
    //   img(src="../assets/images/icons/search.png")
    router-link(to="/checkout", v-if="!searchEnabled" :class="$store.state.cart.items.length > 0 ? 'checkout' : 'checkout disabled'" :event="$store.state.cart.items.length <= 0 ? '' : 'click'") Checkout
    .search-container(v-if="searchEnabled")
      input(type="text", v-model="searchValue", placeholder="Type here to start searching...", @change="searchProduct")

  // .footer-content(v-if="$store.state.mobileStickyFooter.type === 'checkout'")
  //   router-link(to="/").proceed-to-payment Proceed to Payment

  .footer-content(v-if="$store.state.mobileStickyFooter.type === 'payment'")
    router-link(to="/").continue-shopping Continue Shopping

  // .footer-bottom-line
  //   .white-line
</template>

<script>
export default {
  data () {
    return {
      searchEnabled: false,
      searchValue: '',
      sortValue: this.$store.state.sortValue
    }
  },

  watch: {
    '$store.state.sortValue' () {
      this.sortValue = this.$store.state.sortValue
    }
  },
  methods: {
    searchProduct () {
      let searchParam = this.searchValue.split(' ').join('%20')
      dataLayer.push({
        from_favourite: undefined,
        product_slug: undefined,
        search_value: undefined,
        sort_value: undefined,
        from: undefined,
        ecommerce: null
      })
      dataLayer.push({
        event: 'search_product',
        user_email: this.$store.getters.getUserEmail,
        search_value: searchParam,
        from: 'mobile-footer'
      })
      this.searchValue = ''
      this.searchEnabled = false
      this.$router.push(`/search?value=${searchParam}`)
    },

    toggleFilterTab () {
      if (this.$store.state.mobileFilterTabState) {
        this.$store.commit('setMobileFilterTabState', false)
      } else {
        this.$store.commit('setMobileFilterTabState', true)
      }
    },

    activateMobileSidebar () {
      if (this.$store.state.mobileSidebarActivated) {
        this.$store.commit('setMobileSidebarState', false)
        this.$store.commit('setSidebarThemeState', false)
      } else {
        this.$store.commit('setMobileSidebarState', true)
      }
    },

    quantityInCart () {
      const productSlug = this.$route.params.slug.replace('.html', '')
      if (this.$store.state.mobileStickyFooter.type === 'addToCart') {
        if (productSlug) {
          const selectedProduct = this.$store.state.cart.items.find(cartItem => cartItem.slug === productSlug)
          if (selectedProduct) {
            return '(' + selectedProduct.quantity + ')'
          } else {
            return ''
          }
        }
      }
    },

    updateSortByValue () {
      this.$store.commit('updateSortBy', this.sortValue)
    },

    inWishList (productId) {
      const selectedProduct = this.$store.state.favouriteItems.find(item => item.product_id === productId)
      if (selectedProduct) {
        return true
      } else {
        return false
      }
    },

    async addToWishlist (productId) {
      this.$store.commit('setLoadingState', true)
      await this.$store.dispatch('addToFavourites', productId)
      this.$store.commit('setLoadingState', false)
    },

    async removeWishlistItem (productId) {
      const selectedProduct = this.$store.state.favouriteItems.find(item => item.product_id === productId)
      this.$store.commit('setLoadingState', true)
      await this.$store.dispatch('removeWishlistItem', selectedProduct.id)
      this.$store.commit('setLoadingState', false)
    },

    async addToCart (product) {
      this.$store.commit('setLoadingState', true)

      try {
        await this.$store.dispatch('addToCart', { productId: product.id })

        if (product.selectableGifts && product.selectableGifts.length > 0 && !this.$store.state.cart.items.find(item => product.selectableGifts.find(reward => reward.id === item.productId))) {
          this.$store.commit('setSelectableGifts', product)
          this.$store.commit('activateModal', { modalName: 'freeGift' })
        }

        this.$store.commit('setLoadingState', false)
        this.$store.commit('enableCartDropdown')
      } catch (error) {
        this.$store.commit('setLoadingState', false)
        this.$store.commit('activateModal', {
          modalName: 'message',
          textContent: error.response.data,
          characterImageOne: 'notify-body',
          characterImageTwo: 'notify-hand',
          ctaText: 'Continue Shopping',
          ctaAction: () => window.location.reload()
        })
      }
    },

    showNotifyMeModal (productId) {
      this.$store.commit('activateModal', { modalName: 'notifyMe', productId })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../sass/_variables.sass"

.sticky-footer
  position: fixed
  bottom: 0
  left: 0
  width: 100vw
  background-color: $yellow
  z-index: 101
  .footer-content
    display: flex
    flex-wrap: wrap
    align-items: center
    padding: 10px 0 10px 0
    .nav, .search, .favourite
      padding: 0 5px
      border-right: 1px solid white
      box-sizing: border-box
      cursor: pointer
      img
        width: 35px
    .search
      &.borderless
        border-right: 0
    .filter, .sort-by, .add-to-cart, .out-of-stock
      flex-grow: 1
      text-align: center
      font-size: 16px
      line-height: 18px
      padding: 10px
      cursor: pointer
      margin: 0 10px

    .sort-by
      margin-right: 0
      flex: 1
      select
        cursor: pointer
        // -webkit-appearance: none
        // width: 50%
        display: block
        // margin: 0 auto
        font-size: 16px
        line-height: 18px
        outline: none
        background-color: transparent
        border: 0
        margin: 0 auto

    .proceed-to-payment
      display: block
      width: 100%
      margin: 0 16px
      color: white
      background-color: #EE7500
      padding: 10px 0
      font-size: 16px
      text-align: center

    .continue-shopping
      display: block
      width: 100%
      color: white
      background-color: $blue
      padding: 10px 0
      margin: 0 16px
      font-size: 16px
      text-align: center
    .sort-by
      border-left: 1px solid white
    .add-to-cart
      background-color: #EE7500
      color: white
      border-left: 2px solid #EE7500
    .out-of-stock
      background-color: #545454
      color: white
    .favourite
      border-right: none
      padding-left: 0
    .checkout
      flex-grow: 1
      margin: 0 10px
      padding: 10px 0
      background-color: #EE7500
      color: white
      text-align: center
      &.disabled
        pointer-events: none
        background-color: #A5A5A5 !important
        color: white
        border: 0
    .search-container
      flex: 1
      // margin: 0 10px
      padding: 0
      background-color: transparent
      input
        width: 100%
        padding: 10px
        box-sizing: border-box
        background-color: transparent
        border: 0
        font-size: 14px
        &::placeholder
          color: #858585

  .footer-bottom-line
    width: 100%
    padding-bottom: 10px
    .white-line
      background-color: white
      width: 136px
      height: 6px
      display: block
      margin: 0 auto
      border-radius: 5px
</style>
